import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TeacherSwitchModule } from '../../shared/teacher-switch/teacher-switch.module';
import { ArrowLinkModule } from '../../shared/arrow-link/arrow-link.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslatePipeModule } from '../../shared/translate.pipe';
import { GenericTileModule } from '../generic-tile/generic-tile.module';
import { LiveClassStateComponent } from '../live-class-tile/live-class-state/live-class-state.component';
import { LiveClassTileComponent } from '../live-class-tile/live-class-tile.component';
import { LiveClassTypeComponent } from '../live-class-tile/live-class-type/live-class-type.component';
import { LiveClassWeekScheduleComponent } from '../live-class-week-schedule/live-class-week-schedule.component';
import { LiveClassHeaderComponent } from './live-class-header/live-class-header.component';
import { LiveClassSlidesLinkComponent } from './live-class-slides-link/live-class-slides-link.component';

@NgModule({
  imports: [CommonModule, ArrowLinkModule, TranslatePipeModule, GenericTileModule, SharedModule, TeacherSwitchModule],
  declarations: [
    LiveClassHeaderComponent,
    LiveClassSlidesLinkComponent,
    LiveClassWeekScheduleComponent,
    LiveClassTileComponent,
    LiveClassStateComponent,
    LiveClassTypeComponent,
  ],
  exports: [
    LiveClassHeaderComponent,
    LiveClassSlidesLinkComponent,
    LiveClassWeekScheduleComponent,
    LiveClassTileComponent,
    TeacherSwitchModule
  ],
})
export class LiveClassSharedModule {}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-shared/live-class-shared.module.ts